export const MODAL_STUDENT_PAY_SUBSCRIPTION = 'licenses:student-pay-subscription'
